import {
  Permission,
  StudyPermission,
  SitePermission,
  SubjectPermission,
  ReadTaskPermission,
  QCTaskPermission,
  QueryPermission,
  StudyUserManagementPermission,
  StudyReportPermission,
} from '@auth/permissionsEnum'
import { RouteConfig, ROUTES } from 'src/routes'

type TabItem = {
  route: RouteConfig
  permissions?: Permission[]
}
export const tabItems: TabItem[] = [
  {
    route: ROUTES.STUDY_DETAILS,
    permissions: [StudyPermission.VIEW_USER_STUDY],
  },
  {
    route: ROUTES.SITES,
    permissions: [SitePermission.ALL, SitePermission.VIEW_ALL],
  },
  {
    route: {
      ...ROUTES.SUBJECTS,
      aliasRoutes: [ROUTES.SUBJECTS_TIMEPOINTS.path],
    },
    permissions: [SubjectPermission.ALL, SubjectPermission.LIST, SubjectPermission.LIST_FOR_OWN_SITE],
  },
  {
    route: ROUTES.READER_TASKS,
    permissions: [
      ReadTaskPermission.VIEW_ASSIGNED_TASKS,
      ReadTaskPermission.VIEW_COMPLETED_TASKS,
      ReadTaskPermission.VIEW_SKIPPED_TASKS,
      ReadTaskPermission.VIEW_TASK_POOL,
      ReadTaskPermission.ALL,
    ],
  },
  {
    route: ROUTES.QC_TASKS,
    permissions: [
      QCTaskPermission.VIEW_ASSIGNED_TASKS,
      QCTaskPermission.VIEW_COMPLETED_TASKS,
      QCTaskPermission.VIEW_TASK_POOL,
      QCTaskPermission.MANAGE_TASKS,
    ],
  },
  {
    route: ROUTES.QUERIES,
    permissions: [QueryPermission.ALL, QueryPermission.LIST_ALL, QueryPermission.LIST_FOR_OWN_SITE],
  },
  {
    route: ROUTES.ACCOUNT_MANAGEMENT,
    permissions: [StudyUserManagementPermission.ALL, StudyUserManagementPermission.LIST_STUDY_USERS],
  },
  {
    route: ROUTES.STUDY_REPORTS,
    permissions: [StudyReportPermission.ALL, StudyReportPermission.VIEW_ALL_REPORTS],
  },
]

export const reader_excluded_tabs = [ROUTES.STUDY_DETAILS]
export const study_overview_excluded_role = ['Primary_Reader']
